import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.authority,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    // Where OOR staff land after an interactive login when the auto-login
    // guard has no saved deep link to restore (e.g. signing in from Home).
    // The library skips this on silent renewals and lets a saved deep link win,
    // so "where do we go after login?" stays answered in this one place.
    postLoginRoute: '/dashboard',
    clientId: environment.clientId,
    scope: environment.scope,
    responseType: environment.responseType,
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    // URLs the authInterceptor attaches the access token to
    secureRoutes: [environment.apiUrl],
  },
};
